export const rae = {
  operation_type_router: "operation_type_router",
  internet: "internet_button",
  wireless: "wireless_button",
  edit_devname_bt: "Apply_new_edit_bt",
  ap_wireless: "Apply_wireless_bt",
  APaddr1: "WPethr",
  APmask1: "WMask",
  APgateway1: "WGateway",
  APDAddr1: "DAddr",
  APPDAddr1: "PDAddr",
};

export default rae;
